export enum ScheduleCategoriesTypes {
  period = 1,
  break = 2,
  registration = 3
}
